import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './HistoryConsentsList.css';
import _ from 'lodash';
import {Table, Badge} from 'reactstrap';
import {sharedLabelsPath} from "../../../../reducers/common/localization";
import IconContainer from "../../../commonComponents/iconContainer/IconContainer";
import FormWrapper from "../../../commonComponents/formWrapper/FormWrapper.container";
import moment from "moment/moment";
import PaginationHistoryConsentsList from '../../../commonComponents/paginationComponent/PaginationHistoryConsentsList.container';
import {CONSENT_REQUESTS_FILTER} from "../../../../reducers/consent/organizationConsents";

const CARD_STATUS_COLOR = {
    [CONSENT_REQUESTS_FILTER.REJECTED]: "danger",
    [CONSENT_REQUESTS_FILTER.EXPIRED]: "warning",
    [CONSENT_REQUESTS_FILTER.REVOKED]: "secondary",
    [CONSENT_REQUESTS_FILTER.GRANTED]: "success",
};

const DEFAULT_STATUS_LIST = [CONSENT_REQUESTS_FILTER.REJECTED, CONSENT_REQUESTS_FILTER.EXPIRED, CONSENT_REQUESTS_FILTER.REVOKED, CONSENT_REQUESTS_FILTER.GRANTED];

class HistoryConsentsList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedStatuses: DEFAULT_STATUS_LIST
        }
    }

    componentDidMount() {
        this.props.onLoadData(this.state.selectedStatuses);
    }

    render() {
        return (
            <div className='consents-history-list-container'>
                <FormWrapper>
                    <h4 className='page-label'>{_.get(this.props.translation, 'consents.consents_history_label')}</h4>
                    <div className="consents-history-management-menu">
                        <div className="consents-history-status-label">{_.get(this.props.translation, 'consents.show_consents_with_status_label')}</div>
                        {this.renderStatusCheckboxes()}
                    </div>
                    <PaginationHistoryConsentsList statuses={this.state.selectedStatuses}/>
                    {this.renderTable()}
                </FormWrapper>
            </div>
        );
    }

    renderStatusCheckboxes = () => {
        return _.map(DEFAULT_STATUS_LIST, (status, index) => (
            <div key={index} className={"consents-history-status-icon-container"+ (this.state.selectedStatuses.includes(status)? " olive-green" : "")}
                 onClick={this.toggleSelectedStatuses(status)}>
                <IconContainer
                    className="consents-history-status-icon"
                    icon={"check_box" + (this.state.selectedStatuses.includes(status) ? "" : "_outline_blank")}
                    title={_.get(this.props.translation, 'consents.status.' + status)}
                />
                {_.get(this.props.translation, 'consents.status.' + status)}
            </div>
        ))
    }

    renderTable = () => {
        if (this.props.loading) {
            return (
                <div className="consents-history-list-status-message-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                </div>
            );
        }
        if (_.isNil(this.props.data) || this.props.data.length === 0) {
            return (
                <div className="consents-history-list-status-message-container">
                    <h6>{_.get(this.props.translation, 'consents.consents_history_no_data_label')}</h6>
                </div>
            );
        }

        return (
            <Table className='consents-history-list-table'>
                <thead>
                <tr>
                    <th>{_.get(this.props.translation, 'consents.status_label')}</th>
                    <th>{_.get(this.props.translation, 'consents.person_label')}</th>
                    <th>{_.get(this.props.translation, 'consents.job_label')}</th>
                    <th>{_.get(this.props.translation, sharedLabelsPath.company_label)}</th>
                    <th>{_.get(this.props.translation, sharedLabelsPath.email_label)}</th>
                    <th>{_.get(this.props.translation, 'consents.expired_on_label')}</th>
                </tr>
                </thead>
                <tbody>
                {this.renderConsentsData()}
                </tbody>
            </Table>
        )
    };

    renderConsentsData = () => {
        return _.map(this.props.data, (consentData, index) => (
            <tr className="consents-history-list-row" key={index}>
                <td className='status-td'
                    data-th={_.get(this.props.translation, 'consents.status_label') + ':'}>
                    <span className="badge-container">
                        <Badge color={CARD_STATUS_COLOR[consentData.status]}>
                            {_.get(this.props.translation, 'consents.status.' + consentData.status)}
                        </Badge>
                    </span>
                </td>
                <td className='person-td'
                    data-th={_.get(this.props.translation, 'consents.person_label') + ':'}>
                    {!_.isNil(consentData.requester) ? consentData.requester.identityAlias.firstName + " " + consentData.requester.identityAlias.lastName : '-'}
                </td>
                <td className='job-td'
                    data-th={_.get(this.props.translation, 'consents.job_label') + ':'}>
                    {!_.isNil(consentData.jobDescription) ? consentData.jobDescription.title : '-'}
                </td>
                <td className='company-td'
                    data-th={_.get(this.props.translation, sharedLabelsPath.company_label) + ':'}>
                    {consentData.organization.name}, {_.get(this.props.translation, 'countries.' + consentData.organization.address.countryCode)}
                </td>
                <td className='email-td'
                    data-th={_.get(this.props.translation, sharedLabelsPath.email_label) + ':'}>
                    {!_.isNil(consentData.contactEmail)?  <a href={"mailto:" + consentData.contactEmail}>{consentData.contactEmail}</a> : '-'}
                </td>
                <td className='expired-on-td'
                    data-th={_.get(this.props.translation, 'consents.expired_on_label') + ':'}>
                    {!_.isNil(consentData.grantedTill) ? moment(consentData.grantedTill).format('LL') : '-'}
                </td>
            </tr>
        ))
    };

    toggleSelectedStatuses = (currentStatus) => () => {
        let newSelectedStatuses;
        if (this.state.selectedStatuses.includes(currentStatus) && this.state.selectedStatuses.length !== 1) {
            newSelectedStatuses = this.state.selectedStatuses.filter(status => status !== currentStatus);
        } else {
            newSelectedStatuses = _.union(this.state.selectedStatuses, [currentStatus]);
        }
        if (!_.isEqual(newSelectedStatuses, this.state.selectedStatuses)) {
            this.setState({selectedStatuses: newSelectedStatuses});
            this.props.onLoadData(newSelectedStatuses);
        }
    };
}

HistoryConsentsList.propTypes = {
    translation: PropTypes.object.isRequired,
    onLoadData: PropTypes.func.isRequired
};

export default HistoryConsentsList;



// WEBPACK FOOTER //
// ./src/components/consentManagement/consentsList/historyConsentsList/HistoryConsentsList.js